













































import Vue from 'vue';
import { LoadingService, AuthService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import store from '@/store';
import { api, furtherAuthAPI, FURTHER_MEMBER_FEDERATION_API_SUB_URLS } from '@/api';
import {
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { UserGroupResponseModel } from '@/@types/member';
import {
  dateFormat,
  dateFormatYYYYMMDD,
} from '@/constants';
import Cookies from 'js-cookie';

interface Data {
  isLoading: boolean;
  showErrorMessage: boolean;
  errorMessage: string;
  selectedMemberId: string;
  dateFormat: string;
  dateFormatYYYYMMDD: string;
  refreshToken: string;
}

export default Vue.extend({
  name: 'SelectGroup',
  beforeRouteEnter(to, from, next) {
    to.meta.refreshToken = Cookies.get('refreshToken');
    AuthService.deleteCookie();
    const PROMISES = [
      store.dispatch('getUserGroups'),
      getContentArea(['get-user-groups-error']),
    ];
    LoadingService.watchPromises(PROMISES)
      .then((data) => {
        const contentAreas = data[1];
        if (contentAreas) {
          if (contentAreas[0] && contentAreas[0].fields) {
            to.meta.errorMessage = contentAreas[0].fields.content;
          }
        }
        next();
      })
      .catch(() => {
        to.meta.showErrorMessage = true;
        getContentArea(['get-user-groups-error'])
          .then((contentAreas) => {
            if (contentAreas) {
              if (contentAreas[0] && contentAreas[0].fields) {
                to.meta.errorMessage = contentAreas[0].fields.content;
              }
            }
            EventBus.$emit('initialLoadDone');
            next();
          })
          .catch(() => {
            EventBus.$emit('initialLoadDone');
            next();
          });
      });
  },
  data(): Data {
    return {
      isLoading: false,
      showErrorMessage: !!this.$route.meta.showErrorMessage,
      errorMessage: this.$route.meta.errorMessage,
      selectedMemberId: '',
      dateFormat,
      dateFormatYYYYMMDD,
      refreshToken: this.$route.meta.refreshToken,
    };
  },
  computed: {
    userGroups(): UserGroupResponseModel[] {
      return this.$store.getters.userGroups;
    },
  },
  methods: {
    selectGroup(selectedMemberId): void {
      this.isLoading = true;
      this.showErrorMessage = false;
      const refreshToken = this.refreshToken;
      // Open tab immediately to get around overzealous Safari popup blocking
      const authenticatedTab = window.open('/portal/loading', '_blank');
      furtherAuthAPI
        .post(`${FURTHER_MEMBER_FEDERATION_API_SUB_URLS.jwt}`, {
          memberId: selectedMemberId,
          refreshToken,
        })
        .then((response) => {
          const NEW_ID_TOKEN = response.data.value;
          authenticatedTab.location.href = `/portal?id_token=${NEW_ID_TOKEN}`;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.showErrorMessage = true;
        });
    },
    logOut(): void {
      AuthService.signOutUser(true);
    },
  },
  components: {
    FullscreenError,
    FullscreenLoading,
  },
});
